import PropTypes from 'prop-types';
import React, { useState, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useActions, useFetch, useAuth } from '@mssgme/hooks';
import { Spinner, FieldError } from '@mssgme/ui';
import AuthLayout from '../AuthLayout';
import styles from './styles.scss';

// TODO: refactor
export default function AuthByCode({ code, redirectTo }) {
    const { t } = useTranslation('auth');
    const { isAuthenticated } = useAuth();
    const { api } = useActions();
    const { pending, error, getValidationError } = useFetch(async () => api.auth.getToken({ code }), [code]);
    const codeError = getValidationError('code');

    useLayoutEffect(() => {
        if (isAuthenticated) {
            window.location.replace(redirectTo || '/');
        }
    }, [isAuthenticated, redirectTo]);

    return (
        <AuthLayout>
            <div className={styles.root}>
                <div className={styles.header}>
                    <h1>{t('auth.restore.authenticating')}</h1>
                </div>

                {pending ? (
                    <Spinner />
                ) : error ? (
                    codeError ? (
                        <FieldError>{codeError}</FieldError>
                    ) : (
                        <div>{t('errorsList.expired_code')}</div>
                    )
                ) : (
                    ''
                )}
            </div>
        </AuthLayout>
    );
}

AuthByCode.propTypes = {
    code: PropTypes.string.isRequired,
    redirectTo: PropTypes.string,
};

AuthByCode.defaultProps = {
    redirectTo: '/',
};
